module.exports = __webpack_public_path__ + "img/newsImg11-29.554c25ff.png";